'use strict';
import angular from 'angular'

/**
 * Copia os items selecionados para o array alvo
 * @param {array} source - Array fonte para buscar os itens selecionados
 * @param {string} field - Nome do campo a ser mapeado como id
 * @param {array} target - Array alvo para alimentar com os ids selecioandos
 */
function copySelectedItems(source, field, target) {
  angular.forEach(source, (model) => {
    model.selected && target.push({ id: model[field] })
  });
}

function FilterObject() {
  this.documents = [];
  this.categories = [];
  this.places = [];
  this.status = [];
  this.communityAssets = [];
  this.enterprises = [];
  this.organs = [];
  this.programs = [];
  this.sectors = [];
  this.classifications = [];
  this.contracteds = [];
  this.tematicas = [];

  return this;
}

function objectMakerFactory($filter, $translate, onControllerLabelsForLanguageFactory, constantSettings, appSettings) {
  function millisecondsToUTC(_date) {
    const date = new Date(_date);
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds())
  }

  function isConfigExibicaoContratoDetalhesValidos(configExibicao) {
    return angular.isObject(configExibicao) && (
      angular.isArray(configExibicao.fixos) && configExibicao.fixos.length > 1 ||
      angular.isArray(configExibicao.opcionais) && configExibicao.opcionais.length > 1);
  }

  function filterConfigs(list, configExibicao) {
    if (isConfigExibicaoContratoDetalhesValidos(configExibicao)) {
      return list.filter(function(info) {
        if (configExibicao.fixos.includes(info.label)) {
          info.render = true;
          return true;
        } else if (configExibicao.opcionais.includes(info.label)) {
          info.render = true;
          return true;
        }
      })
    } else {
      return list.filter(function(info) {
        return angular.isDefined(info.value);
      });
    }
  }

  return {
    isConfigExibicaoContratoDetalhesValidos:         isConfigExibicaoContratoDetalhesValidos,
    viewObjectControlForMap:                         function() {
      return {
        zoom:                constantSettings.defaultZoom,
        contracts:           [],
        totalContractsValue: 0,
        contractsListSize:   0,
        showContractsInfo:   false,
        heatMap:             null,
        map:                 null,
        geocoder:            null,
        serviceMap:          null,
        infoWindow:          null,
        contractsPins:       [],
        markerCluster:       null
      };
    },
    viewObjectControlForAbout:                       function() {
      return { about: '', cliet: '' };
    },
    viewObjectControlForVideo:                       function() {
      return { cliet: '' };
    },
    viewObjectControlForEmail:                       function() {
      return {
        to:         '',
        name:       '',
        attachment: ''
      };
    },
    viewObjectControlForApp:                         function() {
      return {
        logoUrl:                            '',
        currentContract:                    '',
        contextType:                        '',
        showSearchBar:                      true,
        showFloatingControl:                true,
        showAboutBox:                       false,
        showDetailsBox:                     false,
        showEmailBox:                       false,
        showFilterBox:                      false,
        showingInMap:                       false,
        showConstructionSiteSupervisorsBox: false,
        showLegendBox:                      false,
        showVideoBox:                       false,
        showAlbumBox:                       false,
        showAlbumBoxDetails:                false,
        showEdict:                          false,
        showLicencesEnvironmental:          false,
        showSpecificDetailBox:              false
      };
    },
    viewObjectControlForLayersConfigurator:          function() {
      return { showView: false, activatedConfiguration: 'QUANTITY' };
    },
    viewObjectControlForLayers:                      function() {
      return { activatedLayer: '' };
    },
    viewObjectControlForFloatingBox:                 function() {
      return {
        activeButtonsControl: false,
        makeFloatingOpaque:   false
      };
    },
    viewObjectControlForEdict:                       function() {
      return {
        edict: {}
      };
    },
    viewObjectControlForLicensesEnvironmental:       function() {
      return {
        licenses: []
      };
    },
    viewObjectControlForConstructionSiteSupervisors: function() {
      return {
        supervisors: []
      };
    },
    viewObjectControlForAlbumPhotos:                 function() {
      return {
        mapAlbumPhotos: {}
      };
    },
    viewObjectControlForAlbumPhotosDetail:           function() {
      return {
        mapAlbumPhotos: {},
        photos:         [],
        titlePhotos:    ''
      };
    },
    viewObjectControlForDetails:                     function() {
      return {
        contract:               {},
        informacoesFinanceiras: [],
        informacoesGerais:      [],
        informacoesPrazos:      [],
        executed:               '',
        agreed:                 '',
        chartMaxValue:          '',
        hasFinancier:           ''
      };
    },
    viewObjectControlForFilter:                      function() {
      return {
        filterOptions:    {
          period:              {},
          document:            [],
          categories:          [],
          places:              [],
          status:              [],
          enterprises:         [],
          communityAssets:     [],
          organs:              [],
          contracteds:         [],
          tematicas:           [],
          showVideo:           false,
          showEmpreendimentos: false,
          showBensPublicos:    false,
          showDocumentos:      false,
          showOrgaosPublicos:  false,
          showProgramas:       false,
          showSetores:         false,
          showClassificacoes:  false,
          showContratados:     false,
          showTematicas:       false,
          showTiposObras:      true,
          showLocalidades:     true,
          showSituacoes:       true
        },
        activatedSegment: 'AREA',
        openedPanel:      '',
        textForSearch:    ''
      };
    },
    viewObjectControlForSearchBar:                   function() {
      return {
        textForSearch:       '',
        autocomplete:        null,
        autocompleteService: null,
        location:            {
          fullAddress: '',
          latitude:    '',
          longitude:   ''
        }
      };
    },
    sortingObject:                                   function() {
      return [
        { name: 'contract', label: onControllerLabelsForLanguageFactory.getLabel('CONTRACT'), index: 0, selectedSort: 'name' },
        { name: 'value', label: onControllerLabelsForLanguageFactory.getLabel('VALUE'), index: 1, selectedSort: 'amount' },
        { name: 'date', label: onControllerLabelsForLanguageFactory.getLabel('DATE'), index: 2, selectedSort: 'period.initialDate' }
      ];
    },
    sortingObjectHasDocuments:                       function() {
      return [
        { name: 'contract', label: onControllerLabelsForLanguageFactory.getLabel('CONTRACT_COVENANT'), index: 0, selectedSort: 'id' },
        { name: 'value', label: onControllerLabelsForLanguageFactory.getLabel('VALUE'), index: 1, selectedSort: 'amount' },
        { name: 'date', label: onControllerLabelsForLanguageFactory.getLabel('DATE'), index: 2, selectedSort: 'period.initialDate' }
      ];
    },
    viewObjectControlForContracts:                   function(hasDocuments) {
      return {
        contracts:             [],
        textForSearch:         '',
        selectedSortingOption: {},
        totalContractsValue:   0,
        contractsListSize:     0,
        hasDocuments:          hasDocuments,
        sortingOptions:        hasDocuments ? this.sortingObjectHasDocuments() : this.sortingObject()
      };
    },
    viewObjectControlForMapOptions:                  function() {
      return {
        disableDefaultUI:         true,
        zoom:                     constantSettings.defaultZoom,
        minZoom:                  constantSettings.minZoom,
        maxZoom:                  constantSettings.maxZoom,
        zoomControl:              true,
        streetViewControl:        true,
        streetViewControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
        zoomControlOptions:       { style: google.maps.ZoomControlStyle.LARGE, position: google.maps.ControlPosition.RIGHT_BOTTOM },
        styles:                   [
          { "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "hue": "#ff0000" }, { "saturation": -100 }, { "lightness": 99 }] },
          { "featureType": "road", "elementType": "geometry.stroke", "stylers": [{ "color": "#808080" }, { "lightness": 54 }] },
          { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#ece2d9" }] },
          { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#d6e3b3" }] },
          { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#767676" }] },
          { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ffffff" }] },
          { "featureType": "poi", "stylers": [{ "visibility": "off" }] },
          { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#c6d5a8" }] },
          { "featureType": "poi.park", "stylers": [{ "visibility": "on" }] },
          { "featureType": "poi.sports_complex", "stylers": [{ "visibility": "off" }] },
          { "featureType": "poi.medical", "stylers": [{ "visibility": "off" }] },
          { "featureType": "poi.business", "stylers": [{ "visibility": "off" }] }
        ]
      };
    },
    viewObjectForPDFConfiguration:                   function() {
      return {
        titleFontSize:                  14,
        subtitleFontSize:               12,
        labelFontSize:                  11,
        textFontSize:                   9,
        leftMargin:                     40,
        rightMargin:                    40,
        topMargin:                      60,
        bottomMargin:                   80,
        lineValueOffset:                280,
        defaultSpaceBetweenLines:       15,
        defaultSpaceBetweenSimpleLines: 10,
        defaultSpaceBetweenComponents:  25,
        page:                           1,
        rowPosition:                    { x: 20, y: 60 }
      };
    },
    viewObjectControlForPdfTotal:                    function() {
      return {
        contracts: 0,
        amount:    0
      };
    },
    viewObjectExtractionForFilter:                   function(filters) {
      const filterObject = new FilterObject();

      filterObject.period = {
        initialDate: filters.period.initialDate ? new Date(filters.period.initialDate).getTime() : filters.period.initialDate,
        finalDate:   filters.period.finalDate ? new Date(filters.period.finalDate).getTime() : filters.period.finalDate
      };

      copySelectedItems(filters.documents, 'id', filterObject.documents);
      copySelectedItems(filters.places, 'id', filterObject.places);
      copySelectedItems(filters.status, 'id', filterObject.status);
      copySelectedItems(filters.communityAssets, 'id', filterObject.communityAssets);
      copySelectedItems(filters.enterprises, 'id', filterObject.enterprises);
      copySelectedItems(filters.organs, 'id', filterObject.organs);
      copySelectedItems(filters.contracteds, 'id', filterObject.contracteds);
      copySelectedItems(filters.programs, 'id', filterObject.programs);
      copySelectedItems(filters.sectors, 'id', filterObject.sectors);
      copySelectedItems(filters.classifications, 'id', filterObject.classifications);
      copySelectedItems(filters.tematicas, 'id', filterObject.tematicas);

      	angular.forEach(filters.categories, function(category){
    			const subcategories = [];

		    	if (category.selected){
				    filterObject.categories.push({
					    id: category.id,
					    subcategories: []
				    });
    			} else {
		    		const numSelectedSubcategories = category.subcategories.filter(s => s.selected).map(s => ({id: s.id}));
				    if (numSelectedSubcategories.length > 0) {
					    filterObject.categories.push({
						  id: null,
						  subcategories: numSelectedSubcategories
					  });
				    } else {
					    return;
				    }
			    }
		    });
  		return filterObject;
    },

    viewObjectForClusterIcons: function() {
      const clusterPinArray = [];
      for (let size = 50; size < 100; size += 10) {
        clusterPinArray.push({ textColor: '#fff', url: 'images/clusterer/pin' + size + 'x' + size + '.png', height: size, width: size });
      }
      return clusterPinArray;
    },

    viewSingleDateParsed: function(singleDate) {
      return $filter('date')(millisecondsToUTC(parseInt(singleDate)), 'dd/MM/yyyy');
    },

    viewDateParsed: function(period) {
		if(period.initialDate == null || period.finalDate == null){
			return "⠀"
		} else {
      return this.viewSingleDateParsed(period.initialDate) + (period.finalDate ? ' - ' + this.viewSingleDateParsed(period.finalDate) : '');
      }
    },

    viewObjectForInformacoesGerais:      function(contract, showDetailsContract, configExibicao) {
      const list = [
        {
          label:  contract.covenant ? $translate.instant('label.details.general.covenant') : contract.ajustarLabelSmsSetor ? $translate.instant('label.details.general.contract.ppp') : $translate.instant('label.details.general.contract'),
          type:   'plain',
          value:  contract.name,
          render: true
        },
        {
          label:  $translate.instant('label.details.general.object'),
          type:   'plain',
          value:  contract.description,
          render: true
        },
        {
          label:  $translate.instant('label.details.general.period.validity'),
          type:   'plain',
          value:  this.viewDateParsed(contract.periodValidity),
          render: showDetailsContract
        },
        {
          label:  $translate.instant('label.details.general.period.running'),
          type:   'plain',
          value:  this.viewDateParsed(contract.period),
          render: !contract.covenant
        },
        {
          label:  $translate.instant('label.details.general.validity'),
          type:   'plain',
          value:  contract.daysValidity,
          render: showDetailsContract
        },
        {
          label:  $translate.instant('label.details.general.status'),
          type:   'plain',
          value:  contract.reason === null || $.isEmptyObject(contract.reason) ? contract.status : contract.status + ' - ' + contract.reason,
          render: true
        },
        {
          label:  contract.covenant ? $translate.instant('label.details.general.department.covenant.supervisor') : $translate.instant('label.details.general.department.supervisor'),
          type:   'plain',
          value:  contract.departmentSupervisor,
          render: showDetailsContract
        },
        {
          label:  $translate.instant('label.details.general.department.covenant.auditor'),
          type:   'plain',
          value:  contract.departmentAuditor,
          render: contract.covenant
        },
        {
          label:  $translate.instant('label.details.general.department.benefited'),
          type:   'plain',
          value:  contract.departmentBenefited,
          render: showDetailsContract
        },
        {
          label:  contract.covenant ? $translate.instant('label.details.general.covenant.contractor') : $translate.instant('label.details.general.contractor'),
          type:   'plain',
          value:  contract.contractor,
          render: showDetailsContract
        },
        {
          label:  contract.covenant ? $translate.instant('label.details.general.covenant.company') : $translate.instant('label.details.general.company'),
          type:   'vector',
          value:  contract.companies,
          render: true
        },
        {
          label:  $translate.instant('label.details.general.date.completed'),
          type:   'plain',
          value:  contract.completedDate === null ? '-' : this.viewSingleDateParsed(contract.completedDate),
          render: showDetailsContract
        },
        {
          label:  $translate.instant('label.details.general.deadline.initial'),
          type:   'plain',
          value:  contract.initialContractDeadline,
          render: true
        },
        {
          label:  $translate.instant('label.details.general.deadline.final'),
          type:   'plain',
          value:  contract.finalContractDeadline,
          render: true
        },
        {
          label:  $translate.instant('label.details.general.setor'),
          type:   'plain',
          value:  contract.nmOrgaoSetor,
          render: contract.nmOrgaoSetor !== null && contract.nmOrgaoSetor !== undefined
        },
        {
          label:  $translate.instant('label.details.general.program'),
          type:   'plain',
          value:  contract.dePrograma,
          render: contract.dePrograma !== null && contract.dePrograma !== undefined
        },
        {
          label:  $translate.instant('label.details.general.classificacao'),
          type:   'plain',
          value:  contract.deClassificacao,
          render: contract.deClassificacao !== null && contract.deClassificacao !== undefined
        }
      ];
      return filterConfigs(list, configExibicao);
    },
    viewObjectForInformacoesFinanceiras: function(contract, showDataFinancial, showFinancialPaid, configExibicao) {
      const list = [
        {
          label:  contract.ajustarLabelSmsSetor ? $translate.instant('label.details.financial.initial.ppp') : $translate.instant('label.details.financial.initial'),
          type:   'plain',
          value:  $filter('currency')(contract.originalValue, 'R$ '),
          render: true
        },
        {
          label:  contract.ajustarLabelSmsSetor ? $translate.instant('label.details.financial.added.ppp') : $translate.instant('label.details.financial.added'),
          type:   'plain',
          value:  $filter('currency')(contract.addedValue, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.total'),
          type:   'plain',
          value:  $filter('currency')(contract.contractTotalValue, 'R$ '),
          render: appSettings.source !== 'seinfra',
        },
        {
          label:  $translate.instant('label.details.financial.handout'),
          type:   'plain',
          value:  $filter('currency')(contract.handoutValue, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.updated'),
          type:   'plain',
          value:  $filter('currency')(contract.updatedValue, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.measure.initial'),
          type:   'plain',
          value:  $filter('currency')(contract.initialMeasuredValue, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.measure.readjust'),
          type:   'plain',
          value:  $filter('currency')(contract.readjustMeasuredValue, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.measure.total'),
          type:   'plain',
          value:  $filter('currency')(contract.totalMeasuredValue, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.balance'),
          type:   'plain',
          value:  $filter('currency')(contract.contractBalance, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.balance.updated'),
          type:   'plain',
          value:  $filter('currency')(contract.balanceUpdated, 'R$ '),
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.execution.percentage'),
          type:   'plain',
          value:  contract.executionPercentage.toFixed(2) + '%',
          render: true
        },
        {
          label:  $translate.instant('label.details.financial.paid'),
          type:   'plain',
          value:  $filter('currency')(contract.paidAmount, 'R$ '),
          render: showDataFinancial && showFinancialPaid
        },
        {
          label:  $translate.instant('label.details.financial.paid.total'),
          type:   'plain',
          value:  $filter('currency')(contract.totalPay, 'R$ '),
          render: showDataFinancial && showFinancialPaid
        }
      ];
      return filterConfigs(list, configExibicao);
    },
    viewObjectForInformacoesPrazos:      function(contract, configExibicao) {
      const list = [
        {
          label:  $translate.instant('label.details.date.initial'),
          type:   'plain',
          value:  this.viewSingleDateParsed(contract.period.initialDate),
          render: false
        },
        {
          label:  $translate.instant('label.details.date.final'),
          type:   'plain',
          value:  this.viewSingleDateParsed(contract.period.finalDate),
          render: false
        },
        {
          label:  $translate.instant('label.details.date.original'),
          type:   'plain',
          value:  contract.originalDays === null ? '-' : contract.originalDays,
          render: true
        },
        {
          label:  $translate.instant('label.details.date.added'),
          type:   'plain',
          value:  contract.addedDays === null ? '-' : contract.addedDays,
          render: true
        },
        {
          label:  $translate.instant('label.details.date.stopped'),
          type:   'plain',
          value:  contract.stoppedDays === null ? '-' : contract.stoppedDays,
          render: true
        },
        {
          label:  $translate.instant('label.details.date.current'),
          type:   'plain',
          value:  contract.currentDays === null ? '-' : contract.currentDays,
          render: true
        }
      ];

      return filterConfigs(list, configExibicao); 
    },
    htmlObjectForInfoWindow:             function(contract) {
      return {
        html: '<div id="iw-container"><div class="iw-title">' + contract.name + '</div><p class="p-iw"> ' + contract.summaryDescription + '</p>' +
                ' <p class="p-iw-value-label">' + onControllerLabelsForLanguageFactory.getLabel('CONTRACT_TOTAL_VALUE_l') + '</p><p class="p-iw-value">' + $filter('currency')(contract.contractTotalValue, 'R$ ') + '</p>' +
                '<div style="text-align:right;"><button type="button" class="btn btn-secondary"  ng-click="seeDetails(' + contract.id + ');">' + onControllerLabelsForLanguageFactory.getLabel('DETAILS') + '</button></div>' + '</div>'
      };
    },
  }
}

objectMakerFactory.$inject = ['$filter', '$translate', 'onControllerLabelsForLanguageFactory', 'constantSettings', 'appSettings'];
export default objectMakerFactory



// WEBPACK FOOTER //
// ./src/app/scripts/factories/objectMakerFactory.js